@use 'variables' as *;
@use 'mixins' as *;
@use 'sass:map';

$icon-sizes: (
  'xl': 1.75rem,
  'l': 1.5rem,
  'm': 1.25rem,
  's': 1rem,
  'xs': 0.75rem
);

:host {
  /**
   * @prop --cat-icon-ratio: The aspect ratio of the avatar.
   */
  display: inline-flex;
  vertical-align: middle;
  @include cat-select(none);
}

:host([hidden]) {
  display: none;
}

span {
  display: inline-flex;
}

svg {
  fill: currentColor;
  stroke: none;
  transform-origin: center center;
  height: 1em;
  width: calc(var(--cat-icon-ratio, 1) * 1em);
}

// ----- size

@mixin size($size) {
  .icon-#{$size} svg {
    font-size: map.get($icon-sizes, $size);
  }
}

@include size('xs');
@include size('s');
@include size('m');
@include size('l');
@include size('xl');
